import * as consts from 'redux/constants';

import { IAction } from 'models';

const reducer = (state = {}, action: IAction<string, any>) => {
  const { formName, state: formState } = action.payload || {};

  switch (action.type) {
    case consts.UPDATE_FORM_STATE:
      return {
        ...state,
        [formName]: formState
      };
    default:
      return state;
  }
};

export default reducer;
